import { Button as BaseButton } from 'antd';
import React from 'react';
import styled from 'styled-components';

import { getAppBroker } from 'stores/AppBroker';
import store from 'stores/RootStore';

const Button = styled(BaseButton)`
  align-items: center;
  display: flex;
  font-size: 20px;
  background-color: transparent;
  border: none;
  padding-left: 12px;
  padding-right: 14px;
`;

function GoBackButton() {
  const navigateToParentTearsheet = () => {
    const { clientID, projectID, creativeID, tearsheetID } =
      store.router.params || {};

    if (clientID && projectID && creativeID && tearsheetID) {
      void getAppBroker().navigate({
        clientID: String(clientID),
        projectID: String(projectID),
        creativeID: String(creativeID),
        tearsheetID: String(tearsheetID),
      });
    }
  };

  return (
    <Button onClick={navigateToParentTearsheet}>
      <img src="/images/caret-left-icon.svg" alt="Go back" />
    </Button>
  );
}

export default GoBackButton;
